import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Shared character counter for Input + TextArea. Renders `{length}/{max}`
 * with progressive color thresholds:
 *   - <80%   muted (subtle, doesn't compete with the field)
 *   - >=80%  amber (heads-up — operator is approaching the limit)
 *   - >=100% destructive red (browser will stop accepting more input)
 *
 * Right-aligned by default to match standard composer counter UX
 * (Twitter, Slack, GitHub PR description, etc.).
 */
export function CharCounter({ length, maxLength, inline = false, className = '' }) {
    if (maxLength <= 0)
        return null;
    const ratio = length / maxLength;
    let colorClass = 'text-muted-foreground';
    if (ratio >= 1) {
        colorClass = 'text-destructive';
    }
    else if (ratio >= 0.8) {
        colorClass = 'text-amber-600 dark:text-amber-400';
    }
    const layoutClass = inline ? 'shrink-0 text-xs' : 'mt-1 text-xs text-right';
    return (_jsxs("p", { "aria-live": "polite", className: `${layoutClass} ${colorClass} ${className}`.trim(), children: [length, "/", maxLength] }));
}
//# sourceMappingURL=CharCounter.js.map